import { useState } from 'react'

const TOUR_KEY = 'practicaja_tour'

function isSeen(moduleKey) {
  try {
    return !!JSON.parse(localStorage.getItem(TOUR_KEY) || '{}')[moduleKey]
  } catch { return false }
}

function markSeen(moduleKey) {
  try {
    const tour = JSON.parse(localStorage.getItem(TOUR_KEY) || '{}')
    localStorage.setItem(TOUR_KEY, JSON.stringify({ ...tour, [moduleKey]: true }))
  } catch {}
}

export default function TourBanner({ moduleKey, titulo, descripcion }) {
  const [cerrado, setCerrado] = useState(() => isSeen(moduleKey))

  if (cerrado) return null

  function dismiss() {
    markSeen(moduleKey)
    setCerrado(true)
  }

  return (
    <div className="mx-4 mt-4 mb-1 bg-tienda-accent/10 border border-tienda-accent/30 rounded-2xl p-4 flex gap-3 flex-shrink-0">
      <div className="w-8 h-8 rounded-xl bg-tienda-accent/20 flex items-center justify-center flex-shrink-0">
        <svg className="w-4 h-4 text-tienda-accent" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10" />
          <path d="M12 16v-4M12 8h.01" />
        </svg>
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-tienda-accent font-semibold text-sm">{titulo}</p>
        <p className="text-tienda-muted text-xs mt-0.5 leading-relaxed">{descripcion}</p>
      </div>
      <button
        onClick={dismiss}
        className="text-tienda-muted flex-shrink-0 self-start w-6 h-6 flex items-center justify-center"
        aria-label="Cerrar"
      >
        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
          <path d="M18 6 6 18M6 6l12 12" />
        </svg>
      </button>
    </div>
  )
}
